const colors = {
  white: "#FFFFFF",
  primary: "#1A73E8",
  darkBlue: "#1A237E",
  accentYellow: "#FFD700",
  accentOrange: "#FF6A00",
  accentRed: "#E30613",
  accentGreen: "#1FB25A",
  accentPink: "#F04E98",
  accentPurple: "#7B3F98",
  accentGold: "#D4AF37",
  black: "#000000",
  grey: "#666666",
  grey2:"#4d595aff",
};
export default colors;
